// routes/PermissionRoute.js
import React from 'react';
import { useSelector } from 'react-redux';
import { hasPermission } from 'utils/permissions';
import { Result, Button } from 'antd';

/**
 * PermissionRoute - Wrapper component that checks if user has required permission
 * 
 * @param {Object} props
 * @param {React.Component} props.component - Component to render if authorized
 * @param {string} props.resource - Resource name (e.g., 'events', 'users')
 * @param {string} props.action - Required action (e.g., 'read', 'create', 'update', 'delete')
 */
const PermissionRoute = ({ component: Component, resource, action = 'read', ...rest }) => {
  const user = useSelector(state => state.auth.user);

  // Check if user has the required permission
  const isAuthorized = hasPermission(user, resource, action);

  if (!isAuthorized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '60vh' 
      }}>
        <Result
          status="403"
          title="Access Denied"
          subTitle="Sorry, you don't have permission to access this page."
          extra={
            <Button type="primary" href="/app/dashboard">
              Go to Dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return <Component {...rest} />;
};

export default PermissionRoute;
